/*
 *   File : toast.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : toast
 *   Integrations :
 *   Version : v1.0
 *  Created : 17-01-2022
 */

import React from 'react';

/*import style*/
import styles from '../../styles/components/toast.module.scss';

function Toast(props) {
	return (
		<>
			<div
				className={
					props.type === "success" ?
						styles.e_success
						: styles.e_fail
				}>
				<div className='ps-4'>{props.data}</div>
			</div>
		</>
	);
}
export default Toast;
